var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_550_31664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 44.0005C12.954 44.0005 4 35.0465 4 24.0005C4 12.9545 12.954 4.00049 24 4.00049C35.046 4.00049 44 12.9545 44 24.0005C44 35.0465 35.046 44.0005 24 44.0005ZM24 40.0005C28.2435 40.0005 32.3131 38.3148 35.3137 35.3142C38.3143 32.3136 40 28.244 40 24.0005C40 19.757 38.3143 15.6874 35.3137 12.6868C32.3131 9.6862 28.2435 8.00049 24 8.00049C19.7565 8.00049 15.6869 9.6862 12.6863 12.6868C9.68571 15.6874 8 19.757 8 24.0005C8 28.244 9.68571 32.3136 12.6863 35.3142C15.6869 38.3148 19.7565 40.0005 24 40.0005V40.0005ZM21.244 16.8305L31.002 23.3345C31.1117 23.4075 31.2017 23.5065 31.264 23.6227C31.3262 23.7389 31.3588 23.8687 31.3588 24.0005C31.3588 24.1323 31.3262 24.2621 31.264 24.3783C31.2017 24.4945 31.1117 24.5935 31.002 24.6665L21.242 31.1705C21.1217 31.2503 20.982 31.296 20.8377 31.3028C20.6935 31.3096 20.5501 31.2773 20.4228 31.2092C20.2955 31.1411 20.189 31.0399 20.1145 30.9161C20.0401 30.7924 20.0005 30.6509 20 30.5065V17.4945C20.0003 17.3498 20.0398 17.2079 20.1143 17.0839C20.1889 16.9598 20.2956 16.8583 20.4233 16.7902C20.5509 16.7221 20.6947 16.6898 20.8392 16.6969C20.9837 16.704 21.1236 16.7502 21.244 16.8305V16.8305Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_550_31664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 15,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.3534447c4cd139b2ede0632db29f388d.svg";
export { ForwardRef as ReactComponent };